import getBibTeXJSON from './json';
import { plugins } from '@citation-js/core';

const getBibtxt = function (src, dict, opts) {
  const entries = src.map(entry => {
    const bib = getBibTeXJSON(entry, opts);
    bib.properties.type = bib.type;
    const properties = Object.keys(bib.properties).map(prop => dict.listItem.join(`${prop}: ${bib.properties[prop]}`)).join('');
    return dict.entry.join(`[${bib.label}]${dict.list.join(properties)}`);
  }).join('\n');
  return dict.bibliographyContainer.join(entries);
};

const getBibtxtWrapper = function (src, html) {
  const dict = plugins.dict.get(html ? 'html' : 'text');
  return getBibtxt(src, dict);
};

export { getBibtxt };
export default getBibtxtWrapper;